import React, {useEffect, useState} from "react";
import {Box, Pagination, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Grid, Tooltip} from "@mui/material";
import {useSearchParams} from "react-router-dom";
import {AdminLogsPageinationResponse} from "../data/AdminLogsPageinationResponse";
import {formatTimestamp} from "../utils";
import {PoliceUser} from "../components/PoliceUser";
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';

export const AdminLogsPage = () => {
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams()
    const [page, setPage] = useState(searchParams.get("page") ?? "1")
    const [adminLogs, setAdminLogs] = useState<AdminLogsPageinationResponse>({
        totalLogs: 1,
        totalPages: 1,
        logs: []
    });
    const [searchQuery, setSearchQuery] = useState(searchParams.get("query") ?? "")

    useEffect(() => {
        setSearchParams({
            page,
            query: searchQuery
        })
    }, [page, searchQuery, setSearchParams])

    const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(String(value))
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`/api/user/admin/logs/search?page=${page}&query=${searchQuery}`)
                const data = await response.json()
                setAdminLogs(data)
            } catch (error) {
                console.error('Error fetching logs:', error)
            }
        };
        fetchData()
    }, [page, searchQuery])

    const totalPages = adminLogs.totalPages

    return <Stack spacing={1}>
        <Paper variant={"outlined"} style={{
            padding: "16px",
            overflowX: "auto"
        }}>
        <Grid container spacing={2}>
            <Grid sx={{p: 2, display: "flex"}} item xs={12} sm={12} md={12} lg={12}>
                <TextField fullWidth variant="standard" label="Search..." value={searchQuery} onChange={(event) => {
                    setSearchQuery(event.target.value)
                }}/>
                <div style={{flexGrow: 1}}/>
                <Tooltip title="Admin queries can be searched by case insensitive steam names or rp names, while communityids return results for both Admin and Employee queries. You can also filter results by case insensitive action">
                    <QuestionMarkOutlinedIcon sx={{width: "20px", height: "20px"}}/>
                </Tooltip>
            </Grid>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Admin</TableCell>
                        <TableCell>Employee</TableCell>
                        <TableCell>Action</TableCell>
                        <TableCell>Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {adminLogs.logs && adminLogs.logs.map((admin) => {
                        return <TableRow>
                        <TableCell><PoliceUser user={{communityId: admin.adminCommunityId, nick: admin.adminNick}}/></TableCell>
                        <TableCell><PoliceUser user={{communityId: admin.userCommunityId, nick: admin.userNick}}/></TableCell>
                            <TableCell> {admin.action} </TableCell>
                            <TableCell> {formatTimestamp(admin.date)} </TableCell>
                        </TableRow>
                    })
                    }
                </TableBody>
            </Table>
            </Grid>
        </Paper>
        <Box sx={{justifyContent: "center", display: "flex", width: "100%", mt: 2}}>
            <Pagination color={'secondary'} count={totalPages} page={Number(page)} onChange={handleChangePage}/>
        </Box>
    </Stack>
}